import moment from "moment";

export const addOpacity = (color, opacity) => {
    if (typeof color !== "string" || typeof opacity !== "number") {
        throw new Error("Invalid input: color must be a string and opacity must be a number");
    }

    opacity = Math.min(1, Math.max(0, opacity)); // Ensure opacity is between 0 and 1

    // HEX to RGBA conversion
    if (color.startsWith("#")) {
        let hex = color.replace("#", "");

        // Convert short hex format (#RGB) to full hex (#RRGGBB)
        if (hex.length === 3) {
            hex = hex.split("").map(c => c + c).join("");
        }

        if (hex.length === 6) {
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);
            return `rgba(${r}, ${g}, ${b}, ${opacity})`;
        }
    }

    // RGB to RGBA conversion
    const rgbMatch = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
    if (rgbMatch) {
        const [, r, g, b] = rgbMatch.map(Number);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }

    throw new Error("Invalid color format. Use HEX (#RRGGBB or #RGB) or RGB (rgb(r, g, b)).");
}


export const darkenColor = (color, amount = 10) => {
    if (typeof color !== "string" || typeof amount !== "number") {
        throw new Error("Invalid input: color must be a string and amount must be a number.");
    }

    amount = Math.min(100, Math.max(0, amount)); // Ensure the amount is between 0 and 100

    const darken = (channel) => Math.max(0, Math.min(255, channel - (channel * (amount / 100))));

    // HEX to RGB conversion
    if (color.startsWith("#")) {
        let hex = color.replace("#", "");

        // Convert short hex format (#RGB) to full hex (#RRGGBB)
        if (hex.length === 3) {
            hex = hex.split("").map(c => c + c).join("");
        }

        if (hex.length === 6) {
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);

            const darkenedR = darken(r);
            const darkenedG = darken(g);
            const darkenedB = darken(b);

            return `rgb(${darkenedR}, ${darkenedG}, ${darkenedB})`; // Return as RGB
        }
    }

    // RGB to darker RGB conversion
    const rgbMatch = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
    if (rgbMatch) {
        const [, r, g, b] = rgbMatch.map(Number);

        const darkenedR = darken(r);
        const darkenedG = darken(g);
        const darkenedB = darken(b);

        return `rgb(${darkenedR}, ${darkenedG}, ${darkenedB})`;
    }

    throw new Error("Invalid color format. Use HEX (#RRGGBB or #RGB) or RGB (rgb(r, g, b)).");
}

//..get the time
export const getFormattedDateForCalendar = (date) => {
    return moment(date).local().format("MM/DD/YYYY");
};

